import { grantConfers } from './recordGrantLevels'
import type { DraftGrant } from './recordGrantDiff'

/**
 * Whether a restricted workflow has nobody left who may create from it — not even a system admin, since
 * the model exempts no one from a restriction.
 *
 * The access read already drops grants naming a deleted role, set or subject. An archived user or user
 * attribute stays listed so it can be revoked, but admits nobody. An archived group is not marked on the
 * read, so its grant still counts here.
 */
export const isWorkflowClosedToEveryone = ({
  isRestricted,
  grants,
  setPermissionsById,
}: {
  isRestricted: boolean
  grants: readonly DraftGrant[]
  setPermissionsById: ReadonlyMap<string, readonly string[]>
}): boolean =>
  isRestricted &&
  !grants.some(
    (grant) => !grant.canOnlyBeRemoved && grantConfers('workflow', grant.configuration, 'create_request', setPermissionsById)
  )
